<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
  <ClientOnly>
    <LegalCookieBanner />
    <UiOfflineBanner />
  </ClientOnly>
</template>

<script setup lang="ts">
// Inicialización global de la app
const supabase = useSupabaseClient()

// Configurar headers personalizados para Supabase
// (el módulo @nuxtjs/supabase ya maneja auth automáticamente)
</script>

<style>
/* Reset y estilos base que no van en Tailwind */
*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  scroll-behavior: smooth;
}

/* Ocultar scrollbar pero mantener funcionalidad */
.scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}

/* Estilos para botones de carga */
.btn-loading {
  position: relative;
  color: transparent;
}
.btn-loading::after {
  content: '';
  position: absolute;
  width: 16px;
  height: 16px;
  top: 50%;
  left: 50%;
  margin-left: -8px;
  margin-top: -8px;
  border: 2px solid transparent;
  border-top-color: currentColor;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  color: white;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Responsive helpers */
@media (max-width: 640px) {
  .mobile-only { display: block; }
  .desktop-only { display: none; }
}
@media (min-width: 641px) {
  .mobile-only { display: none; }
  .desktop-only { display: block; }
}

/* Print */
@media print {
  .no-print { display: none !important; }
  body { background: white !important; color: black !important; }
}
</style>
